export enum FileType {
  Xdp = 'XDP',
  Pdf = 'PDF',
  Word = 'WORD',
  Excel = 'EXCEL',
  Zip = 'ZIP',
  Invalid = 'INVALID',
}
